import {pageInfo, detail} from './../api';
const planAppointmentLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    detailObj: null,
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = (data.obj || []).map(item => ({ ...item, btns: [true, item.dealStatus == '处理失败'] }));
    },
    DETAIL(state, data) {
      state.detailObj = data.obj;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async detail({commit}, obj) {
      let resp = await detail(obj);
      commit('DETAIL', resp);
    },
  }
}
export default planAppointmentLog



// WEBPACK FOOTER //
// ./src/page/log/mdlzsct/planAppointmentLog/store/planAppointmentLog.store.js